<mat-toolbar [class.not-handset-width]="!(isHandset$ | async)" fxLayoutAlign="center">
  <!-- <span fxFlex></span> -->
  <button mat-icon-button (click)="openMetarSheet()" [ngClass]="{'icn-spinner': metarsLoading$ | async}"
    matTooltip="Metars">
    <mat-icon>filter_drama</mat-icon>
  </button>
  <!-- <span fxFlex></span> -->
</mat-toolbar>
